import { makeComponents } from '@reduxless/core';
import React from 'react';

var _makeComponents = makeComponents(React),
    Container = _makeComponents.Container,
    mapper = _makeComponents.mapper,
    Link = _makeComponents.Link,
    Match = _makeComponents.Match;

export { Container, mapper, Link, Match };